// extracted by mini-css-extract-plugin
module.exports = {"header":"_2PuGrz","body":"_2DfWyg","date":"_3-A88z","helpful":"_3fbmqr","reply":"UzeZDN","text":"_1K6YTc","helpfulText":"_2wGyaS","replyAvatar":"_3n4mHm","shine-lines":"_11x_b8"};